// The step size for navigating the grid cells when a user provides the relevant keyboard input
export const LARGE_STEP = 5;
